import { addDays, format } from 'date-fns';

const ACCOUNTS = [
  'Northwind Health', 'Contoso Retail', 'Fabrikam Energy', 'Tailspin Logistics', 'Litware Financial',
  'Adatum Manufacturing', 'Wingtip Media', 'Proseware Education', 'Lucerne Insurance', 'Margie Travel',
];
const PROJECTS = [
  'Zero Trust Rollout, Phase 2', 'FY27 Firewall Refresh', 'SASE Migration', 'XDR Expansion', 'Identity Services Engine',
  'Email Security Renewal', 'Branch Segmentation', 'Cloud Workload Protection', 'Secure Access Pilot', 'DNS Security Upgrade',
];
const STAGES = ['2 - Qualify', '3 - Technical Validation', '4 - Business Validation', '5 - Negotiate', '6 - Closing'];
const TYPES = ['Demo', 'Pitch', 'Design Session', 'Customer Design', 'POV', 'POC', 'Post Sales Adoption', 'Workshop', 'Briefing'];
const SUBJECTS = ['Technical demo', 'Architecture review', 'Proof of value kickoff', 'Customer design workshop', 'Adoption check-in', 'Executive briefing', 'Whiteboard session', 'Trial readout'];
const STATUSES = ['Completed', 'Completed', 'Completed', 'Open', 'In Progress'];

/** Deterministic pseudo-random so the preview looks the same on every reload. */
function lcg(seed: number) {
  let s = seed;
  return () => {
    s = (s * 1664525 + 1013904223) % 4294967296;
    return s / 4294967296;
  };
}

/** Twenty-two opportunities in the `sf/team-opportunities-se-activities` shape, one of them with no activity. */
export function demoOpportunities(today: Date = new Date()): any[] {
  const rand = lcg(42);
  const pick = <T,>(xs: T[]) => xs[Math.floor(rand() * xs.length)];
  return Array.from({ length: 22 }, (_, i) => {
    const count = i === 21 ? 0 : 1 + Math.floor(rand() * rand() * 14);
    const se_activities = Array.from({ length: count }, (_, j) => ({
      Id: `00T${i}${j}`,
      ActivityDate: format(addDays(today, -Math.floor(Math.pow(rand(), 1.6) * 330)), 'yyyy-MM-dd'),
      Subject: pick(SUBJECTS),
      SE_Service_Type__c: pick(TYPES),
      Status: pick(STATUSES),
    }));
    return {
      id: `006DEMO${String(i).padStart(4, '0')}`,
      Name: PROJECTS[(i * 3) % PROJECTS.length],
      AccountName: ACCOUNTS[i % ACCOUNTS.length],
      StageName: pick(STAGES),
      Amount: Math.round((20000 + rand() * 900000) / 1000) * 1000,
      CloseDate: format(addDays(today, Math.floor(rand() * 180) - 20), 'yyyy-MM-dd'),
      se_activities,
    };
  });
}
